//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CheckboxSection from "@Shared/components/sections/checkbox-section";
import { useAddress } from "@Shared/@Composables/generic/useAddress";
import { computed, defineComponent, ref } from "@vue/composition-api";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { formatAgentForAvatar } from "@Broker/js/custom/utils";
export default defineComponent({
  name: "CoBrokerConfirmationStep",
  components: {
    CheckboxSection,
    ProfileAvatar
  },
  props: {
    currentData: {
      type: Object,
      default: null
    }
  },
  setup(_, {
    emit
  }) {
    const checked = ref(false);
    const fullAddress = address => {
      const {
        fullAddress
      } = useAddress(address);
      return fullAddress.value;
    };
    const changeBackground = computed(() => {
      return checked.value ? "background-color: var(--primary-1)" : "";
    });
    const handleCheckboxChange = val => {
      checked.value = val;
      emit("change-data", {
        consentChecked: val
      });
    };
    return {
      handleCheckboxChange,
      fullAddress,
      checked,
      changeBackground,
      formatAgentForAvatar
    };
  }
});